import { Outlet } from 'react-router';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import ScrollToTop from "../components/ScrollToTop";
import { useFCMRegistration } from '../hooks/useFCMRegistration';

export function RootLayout() {
  useFCMRegistration(); 
  return (
    <div className="min-h-screen bg-white">
      <ScrollToTop/>
      <Navbar />
      <Outlet />
      <Footer />
    </div>
  );
}
